import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend"; // Import the Backend module
import translationFrench from "../src/lang/fr.json";
import translationEnglish from "../src/lang/en.json";

// import en from "../src/lang/en.json";
// import fr from "../src/lang/fr.json";
import translationUrdu from "../src/lang/urdu.json";
import translationArabic from "../src/lang/arabic.json";
import translationAlbanian from "../src/lang/albanian.json";
import translationBurmese from "../src/lang/burmese.json";
import translationChinese from "../src/lang/chinese.json";
import translationCambodian from "../src/lang/cambodian.json";
import translationGerman from "../src/lang/german.json";
import translationGujarati from "../src/lang/gujarati.json";
import translationHebrew from "../src/lang/hebrew.json";
import translationHindi from "../src/lang/hindi.json";
import translationHungarian from "../src/lang/hungarian.json";
import translationIndonesian from "../src/lang/indonesian.json";
import translationItalian from "../src/lang/italian.json";
import translationJapanese from "../src/lang/japanese.json";
import translationKorean from "../src/lang/korean.json";
import translationMongolian from "../src/lang/mongolian.json";
import translationNepali from "../src/lang/nepali.json";
import translationPersian from "../src/lang/persian.json";
import translationPortuguese from "../src/lang/portuguese.json";
import translationRussian from "../src/lang/russian.json";
import translationSerbian from "../src/lang/serbian.json";
import translationSpanish from "../src/lang/spanish.json";
import translationTelugu from "../src/lang/telugu.json";
import translationThai from "../src/lang/thai.json";
import translationTurkish from "../src/lang/turkish.json";
import translationAmharic from "../src/lang/amharic.json";
import translationKurdish from "../src/lang/Kurdish.json";

//get selected language from local storage
const selectedLanguage = localStorage.getItem("SelectedLanguage") || "en";

//Creating object with the variables of imported translation files
const resources = {
  fr: {
    translation: translationFrench,
  },
  en: {
    translation: translationEnglish,
  },
  ur: {
    translation: translationUrdu,
  },
  ar: {
    translation: translationArabic,
  },
  sq: {
    translation: translationAlbanian,
  },
  my: {
    translation: translationBurmese,
  },
  zh: {
    translation: translationChinese,
  },
  km: {
    translation: translationCambodian,
  },
  de: {
    translation: translationGerman,
  },
  gu: {
    translation: translationGujarati,
  },
  he: {
    translation: translationHebrew,
  },
  hi: {
    translation: translationHindi,
  },
  hu: {
    translation: translationHungarian,
  },
  id: {
    translation: translationIndonesian,
  },
  it: {
    translation: translationItalian,
  },
  ja: {
    translation: translationJapanese,
  },
  ko: {
    translation: translationKorean,
  },
  mn: {
    translation: translationMongolian,
  },
  ne: {
    translation: translationNepali,
  },
  fa: {
    translation: translationPersian,
  },
  pt: {
    translation: translationPortuguese,
  },
  ru: {
    translation: translationRussian,
  },
  sr: {
    translation: translationSerbian,
  },
  es: {
    translation: translationSpanish,
  },
  te: {
    translation: translationTelugu,
  },
  th: {
    translation: translationThai,
  },
  tr: {
    translation: translationTurkish,
  },
  am: {
    translation: translationAmharic,
  },
  ku: {
    translation: translationKurdish,
  }
  
};

i18n
  // i18next-http-backend
  // loads translations from your server
  // https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: false,
    fallbackLng: "en",
    resources,
    lng: selectedLanguage,
    ns: ['translation'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      // format: (value, format, lng) => { // legacy usage
      //   if (value instanceof Date) {
      //     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
      //   }
      //   return value;
      // }
    },
  });

export default i18n;